import { CommonModule } from '@angular/common';
import { Component, Input, NgModule, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { Observable } from 'rxjs';

import { TranslateService } from '@codeandweb/ngx-translate';

import { HookResult, StateService, Transition, UIRouterModule } from '@uirouter/angular';

import { ConfirmationService } from 'primeng/api';
import { DividerModule } from 'primeng/divider';
import { DialogService } from 'primeng/dynamicdialog';
import { PanelModule } from 'primeng/panel';
import { ToolbarModule } from 'primeng/toolbar';

import { EventManagerService } from '@app/_global/event-manager.service';
import { Abonne } from '@app/abonne/abonne.model';
import { IPFormModule } from '@app/components/ip-form';
import { Utilisateur } from '@app/utilisateur/utilisateur.model';
import { GlobalModule } from '@global/global.module';
import { AbonneService } from '../abonne.service';

import { simpleComparison } from '@app/_helpers/utils';


@Component({
	selector: 'abonnes-security-tab',
	templateUrl: `abonne-security-tab.component.html`
})
export class AbonneSecurityTabComponent implements OnInit {

	@Input() me: Utilisateur;
	@Input() abonne: Abonne;

	ip_requises: any[] = [];
	pristineIpsRequises: any[];

	isCreation = false;
	canEdit = false;
	editMode = false;
	skipExitStateCheck = false;

	constructor(
		private abonneService: AbonneService,
		private stateService: StateService,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService,
		private eventManager: EventManagerService,
		private translateService: TranslateService,
	) {
	}

	ngOnInit(): void {
		this.ip_requises = this.abonne.ip_requises ?? [];
		this.pristineIpsRequises = structuredClone(this.ip_requises);
		this.canEdit = this.me.uti_administrateur;
	}

	toggleEditMode(status?: boolean) {
		this.editMode = (status !== undefined)? status : !!!this.editMode;
	}

	submit(){
		this.abonneService.updateAbonneIps(this.abonne.abo_id, this.ip_requises)
		.subscribe({
			complete: () => {
				this.eventManager.emit('toast', { severity: 'success', summary: this.translateService.instant('abonnes.security_params_updated') });
				this.skipExitStateCheck = true;
				this.stateService.go('.', undefined, {reload: '^'});
			}
		})
	}

	uiCanExit(newTransition?: Transition): HookResult {
		if (!this.skipExitStateCheck && !simpleComparison(this.pristineIpsRequises, this.ip_requises)) {
			return new Observable<any>(sub => {
				this.confirmationService.confirm({
					defaultFocus: 'reject',
					header: this.translateService.instant('common.leaving_unsaved_form_confirm_header'),
					message: this.translateService.instant('common.leaving_unsaved_form_confirm_message'),
					accept: () => {
						sub.next(true);
						sub.complete();
					},
					reject: () => {
						sub.next(false);
						sub.complete();
					}
				});
			}).toPromise();
		}
	}
}

@NgModule({
	imports: [
		CommonModule,
		GlobalModule,
		UIRouterModule,
		FormsModule,
		ToolbarModule,
		PanelModule,
		DividerModule,
		IPFormModule
	],
	exports: [AbonneSecurityTabComponent],
	declarations: [AbonneSecurityTabComponent]
})
export class AbonneSecurityTabModule { }
